import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import { useSelector, useDispatch } from 'react-redux';
import { saveMenuCategory, toggleNewCategory, clearAPIStatus } from 'store/actions/restaurantMenu';

import isInteger from 'lodash/isInteger';
import isEmpty from 'lodash/isEmpty';

import { showErrorSnackbar } from 'store/actions/snackbarMessage'
import ColorPickerDialog from 'views/Common/ColorPickerDialog';
import { noWheelInputProps } from 'util/utils'
import 'views/Common//App.css';

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 275,
    padding: theme.spacing(2),
    margin: theme.spacing(2)
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
}));

const NewCategory = (props) => {
  const { menuId } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [categoryDescription, setCategoryDescription] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [altName, setAltName] = useState('');
  const [cookingPriority, setCookingPriority] = useState(1);
  const saveTheMenuCategory = (values) => dispatch(saveMenuCategory(values));
  const apiSuccess = useSelector((state) => state.restaurantMenu.apiSuccess);
  const [hideForWeb, setHideForWeb] = useState(false);
  const closeNewCategory = () => dispatch(toggleNewCategory());
  const clearApiStatus = () => dispatch(clearAPIStatus());

  const [isColorPickerDialogOpen, setIsColorPickerDialogOpen] = useState(false);
  const [colorHex, setColorHex] = useState(null);
  const openColorPickerDialog = () => {
    setIsColorPickerDialogOpen(true);
  };

  const closeColorPickerDialog = () => {
    setIsColorPickerDialogOpen(false);
  };

  const handleColorSelected = (color) => {
    setColorHex(color);
  };

  const save = () => {

    if (!isInteger(cookingPriority)) {
      showErrorSnackbar('Please input an interger for the cooking priority')
      return;
    }
    const newCategory = {
      active: true,
      active_begin: null,
      active_end: null,
      hidden_until: null,
      name: categoryName,
      altName,
      description: categoryDescription,
      cookingPriority: Number(cookingPriority),
      menuId,
      hideForWeb,
      colorHex,

    };
    saveTheMenuCategory(newCategory);
  }

  if (apiSuccess) {
    clearApiStatus();
    closeNewCategory();
  }

  const close = () => {
    closeNewCategory();
  };

  const isValid = () => {
    if (isEmpty(categoryName)) {
      return false;
    }
    if (!isInteger(cookingPriority)) {
      return false;
    }
    return true;
  };

  const handleSwitchChange = (event) => {
    const name = event.target.name;
    const value = event.target.checked;
    if (name === 'hideForWeb') {
      setHideForWeb(value);
    }
  };


  return (
    <Card className={classes.root} draggable
      onDragStart={e => {
        e.preventDefault();
        e.stopPropagation();
      }}>
      <CardContent>
        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            label="Category Name"
            margin="dense"
            name="categoryName"
            variant="outlined"
            value={categoryName}
            onChange={e => setCategoryName(e.target.value)}

          />
        </Grid>

        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            label="Category Alternative Name"
            margin="dense"
            name="altName"
            variant="outlined"
            value={altName}
            onChange={e => setAltName(e.target.value)}
            onDragStart={e => {
              e.preventDefault();
              e.stopPropagation();
            }}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            label="Category Description"
            margin="dense"
            name="categoryDescription"
            variant="outlined"
            value={categoryDescription}
            onChange={e => setCategoryDescription(e.target.value)}

          />
        </Grid>

        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            label="Cooking Priority"
            margin="dense"
            name="cookingPriority"
            variant="outlined"
            type="number"
            inputProps={noWheelInputProps}
            value={cookingPriority}
            onChange={e => setCookingPriority(e.target.value)}
            onDragStart={e => {
              console.log(e);
              e.preventDefault();
              e.stopPropagation();
            }}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={hideForWeb}
                onChange={handleSwitchChange}
                name="hideForWeb"
                color="primary"
              />
            }
            label="Hide For Web"
          />
        </Grid>
        <Grid item md={6} xs={12}>

          <div >
            <div className="color-picker-row">
              <span className="color-picker-button">
                <Button variant='outlined' onClick={openColorPickerDialog} >
                  Pick a color
                </Button>
              </span>
              <span className="selected-color" style={{ backgroundColor: colorHex }}>{colorHex}</span>
            </div>
            <ColorPickerDialog
              isOpen={isColorPickerDialogOpen}
              onClose={closeColorPickerDialog}
              onColorSelected={handleColorSelected}
            />
          </div>
        </Grid>
      </CardContent>
      <CardActions>
        <Button variant="outlined" onClick={close}>Cancel</Button>
        <Button variant="outlined" color="primary"
          disabled={!isValid()}
          onClick={save}>Save</Button>
      </CardActions>
    </Card>
  );
};

export default NewCategory;
